(function(){
  var main = document.getElementById('galleryMain');
  if (!main) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function swapTo(btn) {
    var img = btn.querySelector('img');
    if (!img) return;
    var src = img.src;
    var alt = btn.getAttribute('aria-label') || '';
    if (reduced) { main.src = src; main.alt = alt; return; }
    main.classList.add('swapping');
    setTimeout(function() { main.src = src; main.alt = alt; main.classList.remove('swapping'); }, 160);
  }
  document.querySelectorAll('.thumbs button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.getAttribute('aria-current') === 'true') return;
      swapTo(btn);
      document.querySelectorAll('.thumbs button').forEach(function(b) {
        b.setAttribute('aria-current', String(b === btn));
      });
    });
  });
})();

(function(){
  var els = document.querySelectorAll('.reveal');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    els.forEach(function(el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: .12 });
  els.forEach(function(el) { io.observe(el); });
  setTimeout(function() { els.forEach(function(el) { el.classList.add('in'); }); }, 1200);
})();

(function(){
  var toggle = document.getElementById('navToggle');
  var links = document.getElementById('navLinks');
  if (!toggle || !links) return;
  toggle.addEventListener('click', function() {
    var open = links.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  links.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', function() {
      links.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('click', function(e) {
    if (!links.classList.contains('open')) return;
    if (links.contains(e.target) || toggle.contains(e.target)) return;
    links.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
  });
})();
